import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'

export type ActivityStats = {
  user_id: string
  user_telegram_id: number | null
  tg_username: string | null
  first_name: string | null
  last_name: string | null
  email: string | null
  role: string
  role_group: string
  access_level: string | null
  job_title: string | null
  position: string | null
  is_active: boolean
  last_seen_at: string | null
  app_version: string | null
  device_type: string | null
  w0_sessions: number
  w1_sessions: number
  w2_sessions: number
  w3_sessions: number
  w4_sessions: number
  /** Часы за 4 недели по ФАКТИЧЕСКОМУ исполнителю (миграция 20260923120000). */
  hours_4w: number | null
  /** Участник команды разработки (work_board_members). */
  is_developer: boolean | null
  /** Под сколькими чужими учётками работал сам этот человек. */
  worked_as_count: number | null
  /** Часы такой работы — они уже входят в hours_4w. */
  worked_as_hours: number | null
  /**
   * Локальные сессии без имени исполнителя: вся история до 23.09.2026 и работа
   * разработчика под собственной учёткой. В метрики активности не входят.
   */
  dev_sessions: number | null
  dev_hours: number | null
}

export type ScreenLogEntry = {
  screen_name: string
  pathname: string | null
  search: string | null
  route_context: Record<string, unknown> | null
  started_at: string | null
  created_at: string
  duration_sec: number | null
  /** Учётка, под которой работали, если это был не её владелец. */
  acted_as_user_id: string | null
  acted_as_name: string | null
  /** Событие пришло из локальной сборки. */
  is_dev_session: boolean | null
}

export async function fetchTeamActivityStats(): Promise<ActivityStats[]> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('get_team_activity_stats')
  )) as { data: ActivityStats[] | null; error: any }
  if (error) throw error
  return data ?? []
}

export async function fetchUserScreenLog(
  userId: string,
  days = 14,
  limit = 200,
  offset = 0
): Promise<ScreenLogEntry[]> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('get_user_screen_log', {
      p_user_id: userId,
      p_days: days,
      p_limit: limit,
      p_offset: offset,
    })
  )) as { data: ScreenLogEntry[] | null; error: any }
  if (error) throw error
  return data ?? []
}
